export default __webpack_public_path__ + "static/media/LinkIcon.05563811.svg";